@if (market?.runners?.length > 0) {
  @for (runner of market?.runners; track runner?.selectionId) {
    @if (showMarket(runner) | async) {
      <mat-expansion-panel class="exp-panel" [expanded]="true">
        <mat-expansion-panel-header class="exp-panel-header white-panel-indicator">
          <mat-panel-title class="exp-panel-title">
            <a
              [routerLink]="[
                '/app/main',
                {
                  outlets: {
                    navigation: ['event', market?.eventId],
                    content: ['event-markets', market?.eventId],
                  },
                },
              ]"
              class="title-anchor">
              @if (router.url.includes("content:my-markets")) {
                <span>{{ market?.eventName }} - </span>
              }
              {{ "Fancy" | translate }} - {{ runner?.runnerName }}
            </a>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="fm-table-wrapper">
          <table>
            <thead>
              <tr>
                <th class="runner-th" colspan="3">
                  <span>
                    @if (runner?.minBetSize) {
                      {{ "Min Bet" | translate }}: {{ runner?.minBetSize }}&nbsp;&nbsp;
                    }
                    @if (runner?.maxBetSize) {
                      {{ "Max Bet" | translate }}: {{ runner?.maxBetSize }}
                    }
                  </span>
                </th>
                <th class="text-center lay-th">{{ "No" | translate }}</th>
                <th class="text-center back-th">{{ "Yes" | translate }}</th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr app-f-market-row [market]="runner" [metadata]="market" [update]="getRunnerUpdate(runner.selectionId)" [runners]="market?.runners"></tr>
            </tbody>
          </table>
          @if (!allowPlacement) {
            <app-block-overlay />
          }
        </div>
      </mat-expansion-panel>
    }
  }
}
